import { CampaignsProvider } from "./campaigns-context"
import { LeadsListsProvider } from "./leads-lists-context"
import { CompanyListsProvider } from "./company-lists-context"

interface DashboardProviderProps {
  initialCampaigns: { id: number; name: string }[]
  initialLeadsLists: { id: number; name: string }[]
  initialCompanyLists: { id: number; name: string }[]
  children: React.ReactNode
}

export const DashboardProvider = ({
  initialCampaigns,
  initialLeadsLists,
  initialCompanyLists,
  children,
}: DashboardProviderProps) => {
  return (
    <CampaignsProvider initialCampaigns={initialCampaigns}>
      <LeadsListsProvider initialLeadsLists={initialLeadsLists}>
        <CompanyListsProvider initialCompanyLists={initialCompanyLists}>{children}</CompanyListsProvider>
      </LeadsListsProvider>
    </CampaignsProvider>
  )
}
